module.exports = __webpack_public_path__ + "img/service_cloud_6_mob.12e4292a.jpg";